const FormatNumber = (num) => {
  const str = num.replace(/[\.\D]/g, "");
  const newStr = str.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return newStr;
};

export default FormatNumber;
